module.exports = __webpack_public_path__ + "img/headset-drawing.9cd949ea.jpg";